<h1 mat-dialog-title *ngIf="!isBusy" xmlns="http://www.w3.org/1999/html">Edit Event Description</h1>
<div *ngIf="!isBusy; else spinner" class="event-edit-description__form-container">
  <fieldset class="event-edit-description__form-section">
    <legend class="event-edit-description__form-section-title">Event Description</legend>
    <mat-dialog-content [formGroup]="formGroup">
      <mat-form-field class="event-edit-description__formItem">
        <textarea matInput placeholder="Event Description *" formControlName="description" rows="20"
                  [(ngModel)]="aviationEvent.description" (keyup)="textAreaChanged()">
        </textarea>
      </mat-form-field>
      <p class="form-formatting" [class.danger]="!formGroup.valid">Characters remaining: {{charRemainingCnt}}</p>
      <p class="form-formatting" [class.danger]="!formGroup.valid">Max number of characters: 5000</p>
    </mat-dialog-content>
  </fieldset>

  <mat-dialog-actions class="form-formatting">
    <button type="submit" [disabled]="!formGroup.valid" id="saveButton" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template #spinner>
  <div class="spinnerContainer">
    <mat-spinner  class="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </div>
</ng-template>
